<script>
import { SvgToVueCompiler } from '@/common/util/templateCompiler'
import { logSentryException } from '@/common/util/sentry'

/**
 * Make SVG a component and to allow adding reactive attributes.
 * It also set the right role to svg element and its descendant for ARIA.
 *
 * @since KJS-5014
 */
export default {
  name: 'SvgImage',
  props: {
    template: {
      type: String,
      default: undefined,
      required: false
    },
    title: {
      type: String,
      default: null
    },
    decorative: {
      type: Boolean,
      default: true
    }
  },
  render() {
    const template = this.template?.default || this.template
    if (!template) {
      logSentryException(`SvgImage: ${this.title} svg not found`)
      return ''
    }

    const setAriaLabel = !(
      this.$attrs['aria-label'] || this.$attrs['aria-labelledby']
    )

    const compiler = new SvgToVueCompiler()
    return compiler.render(template, {
      title: this.title,
      decorative: this.decorative,
      setAriaLabel
    })
  }
}
</script>
